
// import echarts from 'echarts/lib/echarts'
// import echarts from "echarts"

// const e = require([
//     'line',
//     'tooltip',
//     "bar",
//     "legend",
//     "graph",
//     'pie'
//   ])
   

  // export default e

export const echarts = require('echarts')

